import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services: React.FC = () => {
  return (
    <div className="services-page">
      {/* Header */}
      <section className="services-header section">
        <div className="container-narrow text-center">
          <h1 className="section-title">서비스 소개</h1>
          <p className="section-subtitle">
            EasyAutoCall의 혁신적인 자동 전화 발신 서비스로<br />
            업무 효율을 극대화하세요
          </p>
        </div>
      </section>

      {/* Main Services */}
      <section className="main-services section">
        <div className="container">
          <div className="service-detail-grid">
            <div className="service-detail-card fade-in">
              <div className="service-detail-header">
                <div className="service-detail-icon">📱</div>
                <h2 className="service-detail-title">TTS 자동 전화</h2>
              </div>
              <p className="service-detail-description">
                텍스트를 음성으로 변환하여 자동으로 전화를 발신합니다.
                배차 알림, 긴급 공지, 고객 안내 등 다양한 용도로 활용 가능합니다.
              </p>
              <ul className="service-features-list">
                <li>✓ 대량 발신 지원 (한 번에 수천 건)</li>
                <li>✓ 발신 시간 예약 기능</li>
                <li>✓ 실시간 발신 현황 모니터링</li>
                <li>✓ 미응답 시 자동 재발신</li>
              </ul>
              <Link to="/tts-call" className="btn btn-primary">
                TTS 전화 시작하기
              </Link>
            </div>

            <div className="service-detail-card fade-in" style={{ animationDelay: '0.2s' }}>
              <div className="service-detail-header">
                <div className="service-detail-icon">📋</div>
                <h2 className="service-detail-title">TTS 설문 / 배차 오토콜</h2>
              </div>
              <p className="service-detail-description">
                전화를 통해 자동으로 설문조사를 진행하고 실시간으로 응답을 수집합니다.
                DTMF(버튼 입력)를 통해 간편하게 의견을 수렴할 수 있습니다.
              </p>
              <ul className="service-features-list">
                <li>✓ 맞춤형 설문 템플릿 제공</li>
                <li>✓ DTMF 버튼 응답 수집</li>
                <li>✓ 실시간 응답 집계 및 분석</li>
                <li>✓ 결과 데이터 엑셀 내보내기</li>
              </ul>
              <Link to="/tts-survey" className="btn btn-primary">
                TTS 설문조사 시작하기
              </Link>
            </div>

            <div className="service-detail-card fade-in" style={{ animationDelay: '0.4s' }}>
              <div className="service-detail-header">
                <div className="service-detail-icon">💬</div>
                <h2 className="service-detail-title">대량 문자 발송</h2>
              </div>
              <p className="service-detail-description">
                SMS/LMS를 통해 대량의 문자 메시지를 효율적으로 발송합니다.
                단문(70자)부터 장문(2000자)까지 다양한 형태의 메시지를 지원합니다.
              </p>
              <ul className="service-features-list">
                <li>✓ 단문 SMS / 장문 LMS 지원</li>
                <li>✓ 엑셀/CSV 파일 업로드</li>
                <li>✓ 실시간 발송 현황 확인</li>
                <li>✓ 건당 20원의 저렴한 비용</li>
              </ul>
              <Link to="/sms-send" className="btn btn-primary">
                문자 발송 시작하기
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Features */}
      <section className="additional-features section">
        <div className="container">
          <h2 className="section-title text-center">추가 기능</h2>
          <p className="section-subtitle text-center">
            더욱 강력하고 편리한 부가 기능들
          </p>

          <div className="features-grid">
            <div className="feature-box">
              <div className="feature-box-icon">📊</div>
              <h3 className="feature-box-title">실시간 대시보드</h3>
              <p className="feature-box-description">
                발신 현황을 실시간으로 모니터링하고 상세한 통계를 확인할 수 있습니다.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-box-icon">📁</div>
              <h3 className="feature-box-title">엑셀 일괄 업로드</h3>
              <p className="feature-box-description">
                배차표를 엑셀 파일로 업로드하면 자동으로 일괄 발신 처리됩니다.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-box-icon">🔄</div>
              <h3 className="feature-box-title">자동 재발신</h3>
              <p className="feature-box-description">
                미응답 시 자동으로 재발신하여 누락 없는 알림을 보장합니다.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-box-icon">📝</div>
              <h3 className="feature-box-title">맞춤 템플릿</h3>
              <p className="feature-box-description">
                자주 사용하는 메시지를 템플릿으로 저장하여 손쉽게 재사용할 수 있습니다.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-box-icon">📈</div>
              <h3 className="feature-box-title">상세 리포트</h3>
              <p className="feature-box-description">
                일/주/월별 발신 통계와 성공률, 비용 리포트를 제공합니다.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-box-icon">🔐</div>
              <h3 className="feature-box-title">보안 및 권한</h3>
              <p className="feature-box-description">
                회사별 데이터 격리와 역할 기반 권한 관리로 안전하게 사용할 수 있습니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works section">
        <div className="container-narrow">
          <h2 className="section-title text-center">사용 방법</h2>
          <p className="section-subtitle text-center">
            간단한 4단계로 바로 시작하세요
          </p>

          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3 className="step-title">회원가입 및 로그인</h3>
                <p className="step-description">
                  간단한 정보 입력으로 회원가입하고 로그인합니다.
                </p>
              </div>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3 className="step-title">크레딧 충전</h3>
                <p className="step-description">
                  필요한 만큼 크레딧을 충전합니다. (콜당 30원)
                </p>
              </div>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3 className="step-title">메시지 작성 및 발신</h3>
                <p className="step-description">
                  전화번호와 메시지를 입력하고 발신 버튼을 클릭합니다.
                </p>
              </div>
            </div>

            <div className="step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3 className="step-title">실시간 모니터링</h3>
                <p className="step-description">
                  대시보드에서 발신 현황과 결과를 실시간으로 확인합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta section">
        <div className="container text-center">
          <h2 className="cta-title">지금 바로 시작하세요</h2>
          <p className="cta-description">
            EasyAutoCall과 함께 업무 혁신을 경험해보세요
          </p>
          <Link to="/login" className="btn btn-primary btn-lg">
            무료로 시작하기
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
